import { createFileRoute } from "@tanstack/react-router";

import AddTwitter from "@/features/onboarding/AddTwitter";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/_auth-basic/add-twitter")({
  component: () => (
    <BasicLayout>
      <AddTwitter />
    </BasicLayout>
  ),
});
